var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusinessEmployment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1251 5.39996C17.4579 5.39996 16.917 4.86221 16.917 4.20015V2.40017H12.0838V4.20015C12.0833 4.86221 11.5424 5.39996 10.8751 5.39996C10.2079 5.39996 9.66699 4.86221 9.66699 4.20015V2.40017C9.66699 1.07662 10.7505 0 12.0833 0H16.9164C18.2492 0 19.3333 1.07662 19.3333 2.40017V4.20015C19.3333 4.86221 18.7924 5.39996 18.1251 5.39996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3581 16.0559C15.1406 16.1397 14.8263 16.1999 14.5 16.1999C14.1737 16.1999 13.8594 16.1397 13.5694 16.0317L0 11.5441V20.6998C0 22.524 1.48625 24 3.32311 24H25.6775C27.5143 24 29.0006 22.524 29.0006 20.6998V11.5441L15.3581 16.0559Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 6.90013V9.64792L14.79 14.3521C14.6931 14.3881 14.5969 14.3999 14.5 14.3999C14.4031 14.3999 14.3069 14.3881 14.21 14.3521L0 9.64792V6.90013C0 5.07595 1.48625 3.59996 3.32311 3.59996H25.6775C27.5138 3.59996 29 5.07595 29 6.90013Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessEmployment);
export default __webpack_public_path__ + "static/media/business-employment.f3dae42a.svg";
export { ForwardRef as ReactComponent };